<template>
  <div :style="level===1?'width: 100%;height: 100%':''">
    <!--max:最多缓存数量-->
    <keep-alive :exclude="exclude" max="4">
      <router-view v-if="$route.meta.keepAlive && $route.meta.level===level"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive || $route.meta.level!==level"></router-view>
  </div>
</template>

<script>
export default {
  name: "keep-alive-router",
  data() {
    return {
      // 组件是否去除缓存
      exclude: []
    }
  },
  props: {
    // 用来区别是第几级路由（因为keep-alive的缓存特性，采取书写组件的方法，每一级用到router-view还想要缓存的路由需要用level进行一个区别，保证每一个组件受到一个keep-alive的包裹，还不影响父组件）
    level: {
      type: Number,
    },
  },
  watch: {
    $route(newValue, oldValue) {
      // 如果希望被缓存的页面清除
      if (newValue.params.clear && newValue.meta.level === this.level) {
        // 将该组件放入不被缓存字段中，将其重新加载
        this.exclude.push(newValue.params.componentName)
        //此处是为了当离开该页面的时候，在将其在字段中剔除
        this.$nextTick(() => {
          this.exclude = [];
          // 将isCreate置位false防止一直为true
          if (oldValue.meta.isCreate) oldValue.meta.isCreate = false;
        })
      }
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/common/keep-alive-router.vue